module.exports = __webpack_public_path__ + "img/kz.kz8e060eb.svg";